import { useState } from "react";
import "../private-officers/PvtOfficersLogin.css";
import axios from "../../axios.jsx";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

function OfficersLogin() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();
  const handleSignInSubmit = async () => {
    var reqData = {
      mobile: mobile,
      password: password,
    };
    try {
      const resData = await axios.post("/api/officers-login-b", reqData);
      if (resData.status === 200) {
        Cookies.set('username',resData.data.username);
        Cookies.set('userInfo',resData.data.userInfo);
        navigate("/pendingnotes", {state:{officer:resData.data.username}});
      }
    } catch (e) {
      setLoginError("Invalid Mobile Number or Password");
    }
  };

  return (
    <>
      <div className="Auth-form-container">
        <form className="Auth-form">
          <div className="Auth-form-content">
            <h3 className="Auth-form-title">Officers Sign In</h3>
            <div className="form-group mt-3">
              <label>Mobile</label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="form-control mt-1"
                placeholder="Enter mobile number"
              />
            </div>
            <div className="form-group mt-3">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control mt-1"
                placeholder="Enter password"
              />
            </div>
            <div className="d-grid gap-2 mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleSignInSubmit}
              >
                Submit
              </button>
            </div>
            <span className="text-danger justify-content-center">{loginError}</span>
          </div>
        </form>
      </div>
    </>
  )
}

export default OfficersLogin;